const initialState = {
    anchor: 'left',
    animal: [],
    totalItems: 0,
    open: false,
    id: '',
    brinco: '',
    nome: '',
    registro: '',
    lote: '',
    data_nascimento: '',
    grupo: '',
    status: '',
    obs: '',
    data_cadastro: '',
    usuario_cadastro: '',
    id_cor: '',
    id_fazenda: '',
    data_atualizacao: '',
    usuario_atualizacao: '',
    data_exclusao: '',
    usuario_exclusao: '',
    id_mae: '',
    id_pai: '',
    id_raca: '',
    data_descarte: '',
    intencao_descarte: '',
    escore_corporal: '',
    bst: '',
    nome_mae: '',
    nome_pai: ''
};

export function animal(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_ANIMAL':
            return {
                ...state,
                animal: action.animal,
                totalItems: action.totalItems
            };
        case 'ANIMAL_DETAIL':
            return {
                ...state,
                id: action.id,
                brinco: action.brinco,
                nome: action.nome,
                registro: action.registro,
                lote: action.lote,
                data_nascimento: action.data_nascimento,
                grupo: action.grupo,
                status: action.status,
                obs: action.obs,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                id_cor: action.id_cor,
                id_fazenda: action.id_fazenda,
                data_atualizacao: action.data_atualizacao,
                usuario_atualizacao: action.usuario_atualizacao,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                id_mae: action.id_mae,
                id_pai: action.id_pai,
                id_raca: action.id_raca,
                data_descarte: action.data_descarte,
                intencao_descarte: action.intencao_descarte,
                escore_corporal: action.escore_corporal,
                bst: action.bst,
                nome_mae: action.nome_mae,
                nome_pai: action.nome_pai
            };
        case 'ANIMAL_CLEAR':
            return {
                ...state,
                anchor: 'left',
                animal: [],
                totalItems: 0,
                open: false,
                id: '',
                brinco: '',
                nome: '',
                registro: '',
                lote: '',
                data_nascimento: '',
                grupo: '',
                status: '',
                obs: '',
                data_cadastro: '',
                usuario_cadastro: '',
                id_cor: '',
                id_fazenda: '',
                data_atualizacao: '',
                usuario_atualizacao: '',
                data_exclusao: '',
                usuario_exclusao: '',
                id_mae: '',
                id_pai: '',
                id_raca: '',
                data_descarte: '',
                intencao_descarte: '',
                escore_corporal: '',
                bst: '',
                nome_mae: '',
                nome_pai: ''
            };
        case "ANIMAL_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
